// TODO: after add redux, this file must remove!
import { Package } from '../Types/Booking/Packages';

const packages: Package[] = [
	{
		id: '001',
		title: 'اقتصادی',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 1,
		order_in_duration: 1,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 40,
	},
	{
		id: '002',
		title: 'طلایی',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 1,
		order_in_duration: 5,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: true,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: true,
		average_frames: 35,
	},
	{
		id: '003',
		title: 'استاندارد',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 1,
		order_in_duration: 3,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: true,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 10,
	},
	{
		id: '004',
		title: 'مدلینگ',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 1,
		order_in_duration: 4,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 25,
	},
	{
		id: '005',
		title: 'اقتصادی',
		price: '350000',
		off_price: '30000',
		digitals: 26,
		order: 2,
		order_in_duration: 3,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 40,
	},
	{
		id: '006',
		title: 'طلایی',
		price: '400000',
		off_price: '30000',
		digitals: 26,
		order: 2,
		order_in_duration: 1,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: true,
		average_frames: 35,
	},
	{
		id: '007',
		title: 'استاندارد',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 2,
		order_in_duration: 4,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 10,
	},
	{
		id: '008',
		title: 'مدلینگ',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 2,
		order_in_duration: 2,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 25,
	},
	{
		id: '002',
		title: 'طلایی',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 3,
		order_in_duration: 1,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: true,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: true,
		average_frames: 35,
	},
	{
		id: '003',
		title: 'استاندارد',
		price: '319000',
		off_price: '30000',
		digitals: 26,
		order: 3,
		order_in_duration: 2,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: true,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 10,
	},
	{
		id: '009',
		title: 'اقتصادی',
		price: '3500000',
		off_price: '30000',
		digitals: 26,
		order: 7,
		order_in_duration: 3,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: false,
		average_frames: 40,
	},
	{
		id: '010',
		title: 'طلایی',
		price: '4000000',
		off_price: '30000',
		digitals: 26,
		order: 7,
		order_in_duration: 1,
		shoot_type_id: 28,
		extra_price: '10000',
		is_full: false,
		is_active: true,
		description: '',
		features: ['Feature1', 'Feature2', 'Feature3', 'Feature4'],
		is_gold: true,
		average_frames: 35,
	},
];
export default packages;
